import { signinRedirect } from '../../services/users/identity/user.service';
import LoadingPage from '../../components/Layout/LoadingPage/LoadingPage.component';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';

function Login() {
  function login() {
    signinRedirect();
  }

  useDocumentTitle('Strona logowania');

  login();

  return <LoadingPage />;
}

export default Login;
